<div class="inline-message" [ngClass]="[type, title ? 'content-title' : '', 'inline-message-' + size]">
  <!-- Icon -->
  <div
    *ngIf="!hideIcon"
    class="d-flex"
    [ngClass]="{ 'align-self-baseline h-100': add_nowrap || show_text }"
    [class.mt-1]="size === 'sm' && add_nowrap && !show_text"
  >
    <ds-icon [icon]="icon" class="icon"></ds-icon>
  </div>
  <!-- Text -->
  <div class="text-container">
    <div class="title nowrap" *ngIf="title">
      <strong [innerHTML]="title"></strong>
    </div>
    <!-- !show_text && add_nowrap means text is truncated, so this toggle button allows expanding/collapsing the text -->
    <div
      #bodyText
      class="body"
      [class.nowrap]="expandable && !show_text && add_nowrap"
      [@slideDown]="{
        value: !expandable
          ? 'expanded-auto'
          : show_text
          ? 'expanded'
          : add_nowrap
          ? 'collapsed-' + size
          : 'expanded-auto',
        params: { expanded_height: expanded_height }
      }"
    >
      <ng-container *ngIf="body; else projectedContent">
        <span [innerHTML]="body"></span>
      </ng-container>
      <ng-template #projectedContent>
        <ng-content></ng-content>
      </ng-template>
    </div>
    <div *ngIf="(add_nowrap || show_text) && (callAction || link)">
      <button *ngIf="callAction" type="button" class="link" (click)="onAction()">
        {{ actionLabel || "Ver detalles" }}
      </button>
      <a *ngIf="!callAction && link?.href" class="link" [href]="link.href" [target]="link.target ?? null">{{
        link.label
      }}</a>
      <a *ngIf="!callAction && link?.routerLink" class="link" [routerLink]="link.routerLink">{{ link.label }}</a>
    </div>
  </div>
  <!-- Link / CTA -->
  <div *ngIf="!add_nowrap && !show_text && (callAction || link)" class="d-flex action-position-center">
    <button *ngIf="callAction" type="button" class="link" (click)="onAction()">
      {{ actionLabel || "Ver detalles" }}
    </button>
    <a *ngIf="!callAction && link?.href" class="link" [href]="link.href" [target]="link.target">{{ link.label }}</a>
    <a
      *ngIf="!callAction && link?.routerLink"
      class="link"
      [routerLink]="link.routerLink"
      [queryParams]="link.queryParams"
      >{{ link.label }}</a
    >
  </div>
  <!-- Toggle Button -->
  <div class="d-flex align-self-baseline h-100" *ngIf="expandable && (add_nowrap || show_text)">
    <ds-icon [icon]="show_text ? 'up-arrow' : 'down-arrow'" (click)="showText()" class="icon-arrow"></ds-icon>
  </div>
</div>
